// @ts-nocheck
import ChatAIBubble from '../../../assets/img/png/ai-bubble.png';
import { useState } from 'react';
import ChatComplete from './components/ChatComplete';
import { Conversation } from '../../../@types/IA.type';
import useGrowthbookExperiment from '../../../hooks/useGrowthbookExperiment';
import { useSearchParams } from 'react-router-dom';
import { ChatAgent } from '../../../@types/EnumsAI.enum';
import usePurchases from '../../../hooks/usePurchases';
import InvasiveChatComplete from './components/InvasiveChatComplete';
import { Chats, X } from '@phosphor-icons/react';
import { useStorage } from '../../../shared/utils/general.util';
import ROUTES from '../../../shared/constants/routes';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

const ChatAI = () => {
	const userProfile = useSelector((state: RootState) => state?.profile?.user);
	const { userHavePurchases } = usePurchases();
	const [showChat, setShowChat] = useState(false);
	const [showAlertMrTax, setShowAlertMrTax] = useState(() => {
		const alertClosed = localStorage.getItem('mrTaxAlertClosed');
		return alertClosed ? false : true;
	});
	const { showChatAI } = useGrowthbookExperiment();
	const [searchParams] = useSearchParams();
	const utmSource = searchParams.get('utm_source');
	const isMeli = utmSource?.includes('mercado_libre');
	const agentName = isMeli
		? ChatAgent.WEB_CHAT_MELI
		: ChatAgent.WEB_CHAT_ORCHESTRATOR;

	const initialMessage: Conversation = {
		id: 0,
		user_id: 0,
		thread: [
			{
				role: 'assistant',
				content: `Hola ${userProfile?.first_name}, soy Mr. Tax, tu asistente personal de IA en heru y estoy aquí para ayudarte a entender mejor nuestros servicios, los beneficios de cada uno y guiarte en el paso a paso para la activación. ¡Estoy atento a tus dudas!`,
			},
		],
		created_at: new Date(),
		updated_at: new Date(),
	};

	const initialMessageNoPurchases: Conversation = {
		id: 0,
		user_id: 0,
		thread: [
			{
				role: 'assistant',
				content: `Hola ${userProfile?.first_name}, ¡Estoy listo para ayudarte con tu situación fiscal!`,
			},
		],
		created_at: new Date(),
		updated_at: new Date(),
	};

	if (!showChatAI) return null;

	// if (!userHavePurchases)
	// 	return (
	// 		<InvasiveChatComplete
	// 			handleClose={() => setShowChat(false)}
	// 			initialMessage={initialMessageNoPurchases}
	// 			showLastChat={true}
	// 			chatName={isMeli ? 'Meli x Heru AI' : 'heru AI'}
	// 			agentName={agentName}
	// 			canClose={true}
	// 		/>
	// 	);

	const handleCloseAlert = () => {
		setShowAlertMrTax(false);
		useStorage().setItem('mrTaxAlertClosed', 'true');
	};

	const supportedRoutes = [
		ROUTES.ROOT,
		ROUTES.PLANS_AND_PRICES,
		ROUTES.INVOICING,
		ROUTES.FISCAL_DOCUMENTS,
		ROUTES.ZUBALE_CERTIFICATES,
		ROUTES.RAPPI_CERTIFICATES,
		ROUTES.TAX_PROFILE,
		ROUTES.TAXES,
		ROUTES.SERVICE_STATUS,
		ROUTES.USER_PROFILE,
	];

	if (!supportedRoutes.includes(location.pathname)) return null;

	return (
		<div
			className={`fixed bottom-0 md:bottom-2 right-0 md:right-3 w-full max-w-[500px] ${
				showChat ? 'z-[999]' : 'z-10'
			}`}
		>
			<div className='fixed bottom-14 md:bottom-2 right-2 md:right-4 flex flex-col gap-2 items-end'>
				{!showChat && showAlertMrTax && (
					<div className='w-full max-w-[250px] bg-white rounded-lg overflow-hidden shadow-xl mr-3 fade-in-scale'>
						<div className='bg-h-primary-90/50 px-5 py-3 text-sm'>
							<p className='text-base font-medium text-h-primary-10 flex items-center gap-2 justify-between'>
								Hola, soy Mr Tax
								<button
									className='ml-auto'
									onClick={handleCloseAlert}
								>
									<X
										size={16}
										weight='bold'
										className='opacity-50'
									/>
								</button>
							</p>
							<p className='opacity-80 text-h-primary-10 mt-1'>
								¡Estoy aquí para ayudarte!
							</p>
						</div>
						<button
							onClick={() => setShowChat(true)}
							className='flex gap-2 w-full py-3 items-center px-5 text-h-primary-40'
						>
							<Chats weight='duotone' /> Hablemos
						</button>
					</div>
				)}

				<button
					onClick={() => setShowChat(!showChat)}
					className=' hover:scale-110 transition-all duration-300'
				>
					<img
						src={ChatAIBubble}
						alt='heru-ai'
						className='size-[72px]'
					/>
				</button>
			</div>
			{showChat && (
				<div className='absolute bottom-0 md:bottom-20 right-0 text-sm md:px-2 w-full h-[100dvh] md:h-[80dvh] md:max-h-[800px] flex'>
					<ChatComplete
						handleClose={() => setShowChat(false)}
						initialMessage={initialMessage}
						showLastChat={true}
						chatName={isMeli ? 'Meli x Heru AI' : 'Mr. Tax'}
						agentName={agentName}
					/>
				</div>
			)}
		</div>
	);
};

export default ChatAI;
